export default __webpack_public_path__ + "static/media/effective-collaboration.adbb18ce.png";